import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EMPTY, firstValueFrom, Observable, Subject, timeout } from 'rxjs';
import { environment } from 'projects/service/src/environments/environment';
import { azureMapsEnabled } from 'projects/service/src/app/shared/utils/azure-maps';

const BASE_URL = environment.apiUrl;
@Injectable({
  providedIn: 'root'
})
export class MapsService {

  private _customerFiltering = new Subject<string>();
  public _customerFiltering$ = this._customerFiltering.asObservable();
  // Bypasses the app interceptors so the RIMS access token is not sent to Azure Maps
  private azureMapsHttp = new HttpClient(inject(HttpBackend));
  constructor(private http: HttpClient) { }

  /**
   * Azure Maps Route Directions (API 1.0) between [longitude, latitude] positions, signed with the map control's
   * authentication. Resolves to the same GeoJSON FeatureCollection that azure-maps-rest's
   * `calculateRouteDirections(...).geojson.getFeatures()` returned: one MultiLineString feature per route.
   */
  async getRouteDirectionsFeatures(map: any, coordinates: number[][]): Promise<any> {
    if (!azureMapsEnabled) return []; // Azure Maps off (azureMapsEnabled): nothing is called, nothing billed.
    const query = coordinates.map(([longitude, latitude]) => `${latitude},${longitude}`).join(':');
    await map.authentication.initialize();
    const signed = map.authentication.signRequest({
      url: `https://atlas.microsoft.com/route/directions/json?api-version=1.0&query=${encodeURIComponent(query)}`
    });
    const response: any = await firstValueFrom(
      this.azureMapsHttp.get(signed.url, { headers: new HttpHeaders(signed.headers || {}) }).pipe(timeout(10000))
    );
    const features = response.routes.map((route: any, index: number) => {
      const properties = { ...route, legSummaries: route.legs.map((leg: any) => leg.summary), resultIndex: index };
      delete properties.legs;
      return {
        type: 'Feature',
        geometry: {
          type: 'MultiLineString',
          coordinates: route.legs.map((leg: any) => leg.points.map((point: any) => [point.longitude, point.latitude]))
        },
        properties
      };
    });
    return { type: 'FeatureCollection', features };
  }


  setSearchCustomerFiltering(value: string): void {
    this._customerFiltering.next(value)
  }

  getSearchCustomerFiltering(): Observable<string> {
    return this._customerFiltering$
  }


  getLatLongViaAddress(address: string, addressCode?: string): Observable<any> {
    if (!azureMapsEnabled) return EMPTY; // Azure Maps off (azureMapsEnabled): nothing is called, nothing billed.
    return this.http.post(`${BASE_URL}address/GetLatLong`, { addressCode, address });
  }

  getAllAddressesOfFSTs(payload: any) {
    // let payload = {
    //   "requiresCounts": true,
    //   "onSearch": {
    //       "fieldNames": [
    //           "name",
    //           "name2",
    //           "address",
    //           "address2",
    //           "addressCode",
    //           "city",
    //           "country",
    //           "zipCode",
    //       ],
    //       "operator": "wildcard",
    //       "searchKey": searchTerm,
    //       "ignoreCase": true,
    //       "ignoreAccent": false,
    //       "oprtr": "wildcard"
    //   },
    //   "onPage": {
    //       "pageIndex": 1,
    //       "pageSize": 20
    //   },
    //       "onWhere": {
    //       "ignoreAccent": false,
    //       "isComplex": true,
    //       "condition": "and",
    //       "predicates": [
    //           {
    //               "ignoreAccent": false,
    //               "isComplex": false,
    //               "field": "zipCode",
    //               "operator": "contains",
    //               "value": zipCode,
    //               "ignoreCase": true,
    //               "oprtr": "contains"
    //           }
    //       ],
    //       "ignoreCase": true
    //   },
    //   "parameters": [],
    //   "skip": 0,
    //   "take": -1
    // }
    // if(!zipCode) {
    //   delete payload.onWhere;
    // }
    // The person's technician scope (RIMS API MapsScopeController); same body and response as Maps/GetAllAddressesOfFSTs.
    let url = `${BASE_URL}maps-scope/technicians`;
    return this.http.post(url, payload);
  }


  searchAddressInAzureMaps(query: string): any {
    if (!azureMapsEnabled) return EMPTY; // Azure Maps off (azureMapsEnabled): nothing is called, nothing billed.
    return this.http.get(`https://atlas.microsoft.com/search/address/json?api-version=1.0&query=${query}&typeahead=true&subscription-key=${environment.azureMapKey}`); // environment.keys(.azureMapKey)
  }

  searchAutoCompleteAddressInAzureMaps(query: string, top: any = 20): any {
    if (!azureMapsEnabled) return EMPTY; // Azure Maps off (azureMapsEnabled): nothing is called, nothing billed.
    return this.http.get(`https://atlas.microsoft.com/geocode:autocomplete?api-version=2026-01-01&query=${query}&bbox=-180,18,3,84&typeahead=true&subscription-key=${environment.azureMapKey}&top=${top}`);
  }
  getOpenServiceOrders(payload: any): Observable<any> { //this API needs to take a searchTerm as well
    // The person's technician scope (RIMS API MapsScopeController); same body and response as Maps/GetOpenServiceOrders.
    let url = `${BASE_URL}maps-scope/service-orders`;
    // if(searchTerm || roles || zipCode) {
    //   url += '?';
    //   if(searchTerm && roles && zipCode) url += `searchTerm=${searchTerm}&role=${roles}&zipCode=${zipCode}`;
    //   else if(searchTerm && zipCode) url += `searchTerm=${searchTerm}&zipCode=${zipCode}`;
    //   else if(searchTerm && roles) url += `searchTerm=${searchTerm}&role=${roles}`;
    //   else if(zipCode && roles) url += `zipCode=${zipCode}&role=${roles}`;
    //   else if (roles) url += `role=${roles}`;
    //   else if (zipCode) url += `zipCode=${zipCode}`;
    //   else if (searchTerm) url += `searchTerm=${searchTerm}`;
    // }
    return this.http.post(url, payload);
  }
}
